import { IconContentMathPlus } from '@doltech/icons/IconContentMathPlus';
import cl from 'classnames';
import * as React from 'react';
import { Transforms } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import styled from 'styled-components';

import { Button } from '../../../../../../figma/ButtonV2/ButtonV2';
import { Box } from '../../../../../../figma/Common/BoxV2';
import { BaseOutlineParagraphProps } from '../OutlineParagraphPlugin.types';
import { outlineParagraphTransforms } from '../transforms';

const Main = styled.div`
  display: grid;
  gap: 24px;
`;

interface OutlineParagraphIdeaContainerProps extends BaseOutlineParagraphProps {}

export const OutlineParagraphIdeaContainer = (props: OutlineParagraphIdeaContainerProps) => {
  const { attributes, children, element, isReadOnly } = props;
  const editor = useSlateStatic();

  return (
    <Main {...attributes} className={cl('outline-paragraph-idea-container-element', element.id)}>
      {children}

      {!isReadOnly && (
        <Box paddingLeft="56px" className="font-inter" contentEditable={false}>
          <Button.Secondary
            type="secondary"
            size="large"
            variant="dark"
            onMouseDown={(e) => {
              e.preventDefault();
              const path = ReactEditor.findPath(editor as any, element);
              Transforms.insertNodes(
                editor,
                outlineParagraphTransforms.createOutlineParagraphIdeaNode(),
                { at: [...path, element.children.length] }
              );
            }}
            iconLeft={<IconContentMathPlus />}
          >
            Add Idea
          </Button.Secondary>
        </Box>
      )}
    </Main>
  );
};
